import dateByAddingSpan from "../../modules/definition/calendar/dateFunctions/dateByAddingSpan";
import dateSubtractionFunctions from "../../modules/definition/calendar/dateFunctions/dateSubtractionFunctions";
import dateWithComponents from "../../modules/definition/calendar/dateFunctions/dateWithComponents";
import dateWithTimestamp from "../../modules/definition/calendar/dateFunctions/dateWithTimestamp";
import endDateWithTimestamp from "../../modules/definition/calendar/dateFunctions/endDateWithTimestamp";
import { isTimespanNegative } from "../../modules/definition/calendar/dateFunctions/timespanFunctions";
import { createOldGregorianCalendar } from "../../modules/definition/calendar/gregorianCalendar";
import { immutableRecords } from "../../types";

const oldCalendar = createOldGregorianCalendar();

export const updateStartAndDuration = (calendarRecord, updateDatesInBC, start, span) => {
  if (updateDatesInBC && start.timestamp < 0) {
    const oldStart = dateWithTimestamp(oldCalendar, start.timestamp, start.precision);
    const startDate = dateWithComponents(
      calendarRecord,
      oldStart.era,
      oldStart.year,
      oldStart.month,
      oldStart.day,
      oldStart.hour,
      oldStart.minute,
      oldStart.second,
      oldStart.precision
    );

    const oldEnd = dateByAddingSpan(oldCalendar, oldStart, immutableRecords.TimespanRecord(span));
    const endDate = dateWithComponents(
      calendarRecord,
      oldEnd.era,
      oldEnd.year,
      oldEnd.month,
      oldEnd.day,
      oldEnd.hour,
      oldEnd.minute,
      oldEnd.second,
      oldEnd.precision
    );

    const duration = dateSubtractionFunctions.timespanBetweenDates(calendarRecord, startDate, endDate);
    return {
      startDate: startDate,
      duration: duration
    };
  }
  // If we are not updating, just leave everything alone
  return {
    startDate: dateWithTimestamp(calendarRecord, start.timestamp, start.precision),
    duration: immutableRecords.TimespanRecord(span)
  };
};

export const updateDate = (calendarRecord, updateDatesInBC, start) => {
  if (updateDatesInBC && start.timestamp < 0) {
    const oldStart = dateWithTimestamp(oldCalendar, start.timestamp, start.precision);
    return dateWithComponents(
      calendarRecord,
      oldStart.era,
      oldStart.year,
      oldStart.month,
      oldStart.day,
      oldStart.hour,
      oldStart.minute,
      oldStart.second,
      oldStart.precision
    );
  }
  // If we are not updating, just leave everything alone
  return dateWithTimestamp(calendarRecord, start.timestamp, start.precision);
};

export const updateEndDate = (calendarRecord, updateDatesInBC, end) => {
  if (updateDatesInBC && end.timestamp < 0) {
    const oldEnd = dateWithTimestamp(oldCalendar, end.timestamp, end.precision);
    let result = dateWithComponents(
      calendarRecord,
      oldEnd.era,
      oldEnd.year,
      oldEnd.month,
      oldEnd.day,
      oldEnd.hour,
      oldEnd.minute,
      oldEnd.second,
      oldEnd.precision
    );
    return endDateWithTimestamp(calendarRecord, result.timestamp, result.precision);
  }

  // If we are not updating, just leave everything alone
  return endDateWithTimestamp(calendarRecord, end.timestamp, end.precision);
};

export const updateDateWithOffset = (calendarRecord, updateDatesInBC, start, offset) => {
  if (updateDatesInBC && (start.timestamp < 0 || isTimespanNegative(offset))) {
    const oldStart = dateWithTimestamp(oldCalendar, start.timestamp, start.precision);
    const oldDate = dateByAddingSpan(oldCalendar, oldStart, immutableRecords.TimespanRecord(offset));
    return dateWithComponents(
      calendarRecord,
      oldDate.era,
      oldDate.year,
      oldDate.month,
      oldDate.day,
      oldDate.hour,
      oldDate.minute,
      oldDate.second,
      oldDate.precision
    );
  }
  const oldStart = dateWithTimestamp(calendarRecord, start.timestamp, start.precision);
  return dateByAddingSpan(calendarRecord, oldStart, immutableRecords.TimespanRecord(offset));
};
